import { defineStore } from "pinia";
import type { DetailPassenger, DetailsPassenger, SchedulesPelni, PassengerRequest, PelabuhanResponse, SchedulePelniRequest, SchedulePelniResponse, transactionPelniRequest, transactionPelniResponse, getReportPelniResponse, FarePelni, Pelabuhan } from "~/istypes";
import { useUserStore } from "~/stores/user";

export const usePelniStore = defineStore('pelni', () => {
    const config = useRuntimeConfig();
    const pelabuhanList = ref<Pelabuhan[]>([]);
    const scheduleList = ref<SchedulesPelni[]>([]);
    const fareList = ref<FarePelni[]>([]);
    const InformasiSchedule = ref();
    const passengers = ref();
    const saveToLocalStorage = (key: string, data: any) => {
        localStorage.setItem(key, JSON.stringify(data));
    };

    const userStore = useUserStore();

    const setInformasiSchedule = (data?: any) => (InformasiSchedule.value = data);
    const setScheduleList = (data?: any) => (scheduleList.value = data);
    const setFareList = (data?: any) => (fareList.value = data);
    const setPassengers = (data?: any) => (passengers.value = data);

    const DaftarSchedule = async (data: SchedulePelniRequest) => {
        const headers: Record<string, string> = {};

        headers["Device-Id"] = userStore.deviceId();
        
        if (userStore.token) {
            headers.Authorization = `Bearer ${userStore.token}`;
        }
        try {
            const res = await $fetch<SchedulePelniResponse>(`${config.public.ApiBase}/pelni/get_schedule`, {
                method: "POST",
                body: data,
                headers
            });
            return res;
        } catch (error) {
            setScheduleList();
        }
    }

    const DaftarFare = async (data: SchedulePelniRequest) => {
        if (userStore.token) {
            try {
                const resFare = await $fetch<SchedulePelniResponse>(`${config.public.ApiBase}/pelni/get_schedule`, {
                    method: "POST",
                    body: data,
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                // if (res.status?.code === 200) {
                //     const fareList = res.details?.schedules?.departure?.[0]?.Fares || [];
                //     setFareList(fareList);
                // }

                return resFare;
            } catch (error) {
                setFareList();
            }
        }
    }

    const fetchInformasiSchedule = async (data: SchedulePelniRequest) => {
        try {
            const headers: Record<string, string> = {};

            headers["Device-Id"] = userStore.deviceId();
            
            if (userStore.token) {
                headers.Authorization = `Bearer ${userStore.token}`;
            }
            
            const res = await $fetch<SchedulePelniResponse>(`${config.public.ApiBase}/pelni/get_schedule`, {
                method: "POST",
                body: data,
                
            });


            return res;
        } catch (error) {
            // setInformasiSchedule();
            return error
        }
    }

    const fetchPassengers = async (data: DetailsPassenger) => {
        if (userStore.token) {
            try {
                const res = await $fetch<PassengerRequest>(`${config.public.ApiBase}/passengers`, {
                    method: "POST",
                    body: data,
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });


                return res;
            } catch (error) {
                setPassengers();
            }
        }
    }

    const getPelabuhan = async () => {
        try {
            const res = await $fetch<PelabuhanResponse>(`${config.public.ApiRest}harbours`, {
                method: "GET",
            });

            return res;
        } catch (error) {
            console.error("Error fetching:", error);
        }
    }

    const submitTiketPelni = async (data: SchedulePelniRequest) => {
        try {
            const headers: Record<string, string> = {};

            headers["Device-Id"] = userStore.deviceId();
            
            if (userStore.token) {
                headers.Authorization = `Bearer ${userStore.token}`;
            }
            const res = await $fetch<SchedulePelniResponse>(`${config.public.ApiBase}/pelni/get_schedule`, {
                method: "POST",
                body: data,
                headers
            });


            return res;
        } catch (error) {
            setScheduleList();
        }
    }

    const transaction = async (data: transactionPelniRequest) => {
        if (userStore.token) {
            try {
                const response = await $fetch<transactionPelniResponse>(`${config.public.ApiBase}/pelni/booking_issued`, {
                    method: "POST",
                    body: data,
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return response;
            } catch (error) {
                return error;
            }
        }
    }

    const getReportList = async (start_date: Date | null, end_date: Date | null) => {
        if (userStore.token) {
            try {
                const res = await $fetch<getReportPelniResponse>(`${config.public.ApiBase}/pelni/reports`, {
                    method: "POST",
                    body: {
                        start_date: start_date,
                        end_date: end_date,
                    },
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const getReportDetail = async (pelni_transaction_id: any) => {
        if (userStore.token) {
            try {
                const response = await $fetch<getReportPelniResponse>(`${config.public.ApiBase}/pelni/reports/detail`, {
                    method: "POST",
                    body: {
                        transaction_id: pelni_transaction_id,
                    },
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return response;
            } catch (error) {
                return error;
            }
        }
    }

    return { pelabuhanList, submitTiketPelni, DaftarSchedule, DaftarFare, transaction, getPelabuhan, setInformasiSchedule, setPassengers, fetchInformasiSchedule, fetchPassengers, getReportList, getReportDetail, setScheduleList, setFareList };
})